import api from "../api";
import { toast } from 'vue3-toastify'

export default {
  namespaced: true,
  state: {
    shippiments: {},
  },
  getters: {
    
  },
  actions: {
    async get_shippiments({ commit }) {
      try {
        api.get("/v1/shippiments")
        .then((res) => {
          commit("GET_SHIPPIMENTS", res.data);
        })
        .catch((error) => {
          commit("ERROR_SHIPPIMENT", "Erro os fretes");
        })
        .finally(() => (
          console.log('login request end')
        ));
      } catch (e) {
        commit("ERROR_SHIPPIMENT", e);
      }
    },  
    
  },
  mutations: {
    GET_SHIPPIMENTS(state, data) {
      state.shippiments = data
    },
    ERROR_SHIPPIMENT(state, data) {
      console.log(data)
    },
  }
}